function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import Bulma from '../core';
import Plugin from '../plugin';
/**
 * @module Accordion
 * @since  0.3.0
 * @author  Thomas Erbe <vizuaalog@gmail.com>
 */

var Accordion = /*#__PURE__*/function (_Plugin) {
  _inherits(Accordion, _Plugin);

  var _super = _createSuper(Accordion);

  /**
   * Plugin constructor
   * @param  {Object} options The plugin's options
   * @return {this} The new plugin instance
   */
  function Accordion(options) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _super.call(this, options); // Work out the parent if it hasn't been supplied as an option.

    if (_this.parent === null) {
      _this.parent = _this.option('element').parentNode;
    }
    /**
     * Accordion element.
     * @type {string}
     */


    _this.element = _this.option('element');

    _this.element.setAttribute('data-bulma-attached', 'attached');
    /**
     * Accordion items
     * @type {Array}
     */


    _this.accordions = _this.findAccordions();
    /**
     * Toggle buttons for each accordion item
     * @type {Array}
     */

    _this.toggleButtons = _this.findToggleButtons();

    _this.addToggleButtonEvents();

    return _this;
  }
  /**
   * Find the accordion items within this accordions element
   * @returns {Array} The accordion elements found
   */


  _createClass(Accordion, [{
    key: "findAccordions",
    value: function findAccordions() {
      return this.element.querySelectorAll('.accordion');
    }
    /**
     * Find the toggle buttons within this accordions element
     * @returns {Array} The toggle buttons found
     */

  }, {
    key: "findToggleButtons",
    value: function findToggleButtons() {
      var buttons = [];
      Bulma.each(this.accordions, function (accordion) {
        buttons.push(accordion.querySelector('button.toggle'));
      });
      return buttons;
    }
    /**
     * Add click events to toggle buttons
     * @return {undefined}
     */

  }, {
    key: "addToggleButtonEvents",
    value: function addToggleButtonEvents() {
      var _this2 = this;

      Bulma.each(this.toggleButtons, function (toggleButton, index) {
        // If the button is null, the accordion item has no toggle button
        if (toggleButton !== null) {
          toggleButton.addEventListener('click', function (event) {
            _this2.handleToggleClick(event, index);
          });
        }
      });
    }
    /**
     * Handle the click
     * @param {Object} event The event object
     * @param {number} index Index of the accordion to toggle
     * @return {undefined}
     */

  }, {
    key: "handleToggleClick",
    value: function handleToggleClick(event, index) {
      this.toggleAccordionVisibility(this.accordions[index]);
    }
    /**
     * Show or hide the accordion
     * @param {HTMLElement} accordion The accordion element
     * @return {undefined}
     */

  }, {
    key: "toggleAccordionVisibility",
    value: function toggleAccordionVisibility(accordion) {
      Bulma.each(this.accordions, function (a) {
        a.classList.remove('is-active');
      });

      if (accordion.classList.contains('is-active')) {
        accordion.classList.remove('is-active');
      } else {
        accordion.classList.add('is-active');
      }
    }
    /**
     * Destroy the accordion
     * @return {undefined}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.element = null;
    }
  }], [{
    key: "create",
    value:
    /**
     * Helper method used by the Bulma core to create a new instance.
     * @param  {Object} options The plugin's options
     * @return {Accordion} The newly created instance
     */
    function create(options) {
      return new Accordion(options);
    }
    /**
     * Handle parsing the DOM.
     * @param {HTMLElement} element The root element for this accordion
     * @return {undefined}
     */

  }, {
    key: "parse",
    value: function parse(element) {
      new Accordion({
        element: element
      });
    }
    /**
     * Returns a string containing the element class this plugin supports.
     * @returns {string} The class name.
     */

  }, {
    key: "getRootClass",
    value: function getRootClass() {
      return 'accordions';
    }
  }]);

  return Accordion;
}(Plugin);

Bulma.registerPlugin('accordion', Accordion);
export default Accordion;